import src from "./mobile-hero-with-case.jpg";
export default { src: src, aspect: 0.6135693215339233, width: 832, height: 1356 };